module.exports = new __parcel__URL__("WhiteboardsPaywallDarkV2.e9c25635.svg").toString();